// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionSix-Product {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 500px;
  background: #1c2640;
  padding: 110px 180px 130px;
}
.sectionSix-Product .sectionSix-Product-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 42px;
  line-height: 49px;
  color: #ffffff;
}
.sectionSix-Product .sectionSix-Product-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-left {
  display: flex;
  width: 300px;
  min-height: 300px;
  margin-right: 100px;
  justify-content: flex-end;
  position: relative;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-left .author-image-background {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 192px;
  height: 208px;
  background: #2867b2;
  mix-blend-mode: multiply;
  border-radius: 5px;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-left img {
  width: 246px;
  height: 258px;
  margin-top: 30px;
  z-index: 1;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 300px;
  border-top: 3px solid #ffffff;
  border-bottom: 3px solid #ffffff;
  justify-content: center;
  padding: 15px 0;
  position: relative;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right .sectionSix-Product-content-right-quote {
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 39px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right .sectionSix-Product-content-right-author {
  font-family: Roboto;
  font-size: 22px;
  font-style: italic;
  font-weight: 500;
  line-height: 39px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right .sectionSix-Product-content-right-dots-section {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: absolute;
  bottom: -30px;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right .sectionSix-Product-content-right-dots-section .slide-dot {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: #6d6d6d;
  margin-right: 10px;
  cursor: pointer;
}
.sectionSix-Product .sectionSix-Product-content .sectionSix-Product-content-right .sectionSix-Product-content-right-dots-section .slide-dot.active {
  background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/SectionSix/SectionSix.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AACD;AACC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAEE;EACC,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAAH;AAEG;EACC,kBAAA;EACA,aAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;AAAJ;AAEG;EACC,YAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AAIE;EACC,aAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAFH;AAIG;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKG;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAHJ;AAMG;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAJJ;AAMI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAJL;AAMK;EACC,yBAAA;AAJN","sourcesContent":[".sectionSix-Product {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tmin-height: 500px;\n\tbackground: #1c2640;\n\tpadding: 110px 180px 130px;\n\n\t.sectionSix-Product-title {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 42px;\n\t\tline-height: 49px;\n\t\tcolor: #ffffff;\n\t}\n\n\t.sectionSix-Product-content {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\n\t\t.sectionSix-Product-content-left {\n\t\t\tdisplay: flex;\n\t\t\twidth: 300px;\n\t\t\tmin-height: 300px;\n\t\t\tmargin-right: 100px;\n\t\t\tjustify-content: flex-end;\n\t\t\tposition: relative;\n\n\t\t\t.author-image-background {\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -20px;\n\t\t\t\tleft: 0;\n\t\t\t\twidth: 192px;\n\t\t\t\theight: 208px;\n\t\t\t\tbackground: #2867b2;\n\t\t\t\tmix-blend-mode: multiply;\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t\timg {\n\t\t\t\twidth: 246px;\n\t\t\t\theight: 258px;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\t\t}\n\n\t\t.sectionSix-Product-content-right {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tflex-direction: column;\n\t\t\tmin-height: 300px;\n\t\t\tborder-top: 3px solid #ffffff;\n\t\t\tborder-bottom: 3px solid #ffffff;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 15px 0;\n\t\t\tposition: relative;\n\n\t\t\t.sectionSix-Product-content-right-quote {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 28px;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 39px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: #ffffff;\n\t\t\t}\n\n\t\t\t.sectionSix-Product-content-right-author {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 22px;\n\t\t\t\tfont-style: italic;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 39px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: #ffffff;\n\t\t\t}\n\n\t\t\t.sectionSix-Product-content-right-dots-section {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -30px;\n\n\t\t\t\t.slide-dot {\n\t\t\t\t\twidth: 10px;\n\t\t\t\t\theight: 10px;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\tbackground: #6d6d6d;\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tbackground-color: #ffffff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
